









































import { Vue, Component, Prop } from 'vue-property-decorator'

import Avatar from '@/components/field/avatarUploader/avatar.vue'

@Component({
  name: 'NoteItem',
  components: {
    Avatar
  }
})
export default class NoteItem extends Vue {
  @Prop()
  items?:any[]

  @Prop()
  parent:any

  @Prop()
  activeId:any

  mounted () {
    if (this.items && this.parent) {
      this.items.forEach((item) => {
        const childEl = (this.$refs['tree_node_' + item.id] as Element[])[0]
        const parentEl = (this.$parent.$refs['tree_node_' + this.parent.id] as Element[])[0]
        if (childEl && parentEl) {
          const parentRect = parentEl.getBoundingClientRect()
          const childRect = childEl.getBoundingClientRect()
          const offsetParent = parentRect.left + parentRect.width / 2
          const offsetChild = childRect.left + childRect.width / 2
          const width = offsetParent - offsetChild
          const height = childRect.y - (parentRect.y + parentRect.height)

          const svg = (this.$refs['note_line_' + item.id] as SVGElement[])[0]
          const lineEl = svg.querySelector('.line')!
          svg.style.width = Math.max(Math.abs(width), 1) + 'px'
          svg.style.height = height + 'px'
          svg.style.top = height * -1 + 'px'
          if (width < 0) {
            svg.style.right = childRect.width / 2 + 'px'
            svg.classList.add('svg-style-right')
            // lineEl.setAttribute('x1', '0')
            // lineEl.setAttribute('y1', '0')
            // lineEl.setAttribute('x2', svg.style.width)
            // lineEl.setAttribute('y2', svg.style.height)
          } else if (width > 1) {
            svg.style.left = childRect.width / 2 + 'px'
            svg.classList.add('svg-style-left')
            // lineEl.setAttribute('x1', svg.style.width)
            // lineEl.setAttribute('y1', '0')
            // lineEl.setAttribute('x2', '0')
            // lineEl.setAttribute('y2', svg.style.height)
          } else {
            svg.classList.add('svg-style-center')
          }
        }
      })
    }
  }

  active (item:any) {
    this.$emit('active', item)
  }

  removeThis (item:any) {
    this.$emit('removeThis', item)
  }
}
